module.exports = __webpack_public_path__ + "static/media/0.5feea48e.svg";